import ReportIndex from '../views/Report/Index'

let routes = {
    path: '/reports',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/reports',
            name: 'list-reports',
            component: ReportIndex,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Relatórios',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes
